import DatePickerField from '../../DatePickerField';
import type { FieldRendererProps } from '../types';

export function DateField({
  field,
  className,
  sx,
  hasWhiteFields,
  autoFocus,
  isDisabled,
  isReadOnly,
  onChange,
}: FieldRendererProps) {
  return (
    <DatePickerField
      field={field}
      className={className}
      sx={sx}
      hasWhiteFields={hasWhiteFields}
      autoFocus={autoFocus}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      onChange={onChange}
    />
  );
}
